import { Box, Typography } from '@mui/material';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { notificationPanelWrapperHeader } from '../../constants';
var sx = {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
};
export var NotificationPanelHeader = memo(function () {
    return (React.createElement(Box, { className: notificationPanelWrapperHeader, p: 1.5 },
        React.createElement(Typography, { component: "h2", sx: sx },
            React.createElement(FormattedMessage, { id: "notification.notifications", defaultMessage: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F" }))));
});
